const commonProps = {
  visible: {
    type: Boolean,
    default: true
  },
  zIndex: {
    type: Number
  },
  reEventWhenUpdate: {
    type: Boolean,
    default: false
  },
  extraOptions: {
    type: Object
  }
};
const buildProps = (props) => {
  return Object.assign({}, commonProps, props);
};

export { buildProps, commonProps };
//# sourceMappingURL=buildHelper.mjs.map
